import { useEffect, useRef, useState } from "react";
import { useDispatchApp } from "../lib/redux";
import { getPathDatabaseByRole } from "../actions/auth";
import {
  reportCreativeJobError,
  startListenerCreativeJobs,
  stopListenerCreativeJobs,
  syncCreativeJobNotifications,
} from "../actions/creativeJobs";
import {
  getCreativeJobSentryFailure,
  selectUnreportedCreativeJobFailures,
} from "../utils/creativeJobSentryReport";

const collectCreativeFailureIDs = (jobs) => {
  const failureIDs = new Set();
  (jobs || []).forEach((job) => {
    const failure = getCreativeJobSentryFailure(job);
    if (failure) failureIDs.add(failure.jobID);
  });
  return failureIDs;
};

export const useCreativeJobsListener = () => {
  const dispatch = useDispatchApp();
  const listenerRef = useRef(null);
  const reportedFailureIDsRef = useRef(null);
  const [initialSyncDone, setInitialSyncDone] = useState(false);
  const { userID: advertiserID } = dispatch(getPathDatabaseByRole());

  useEffect(() => {
    setInitialSyncDone(false);
    reportedFailureIDsRef.current = null;

    if (!advertiserID) return undefined;

    dispatch(
      startListenerCreativeJobs({
        advertiserID,
        onReferenceAvailable: (reference) => {
          listenerRef.current = reference;
        },
        onUpdatedDataCallback: (jobs) => {
          dispatch(syncCreativeJobNotifications(jobs));
          const reportedIDs = reportedFailureIDsRef.current;
          if (reportedIDs === null) {
            reportedFailureIDsRef.current = collectCreativeFailureIDs(jobs);
            setInitialSyncDone(true);
            return;
          }

          selectUnreportedCreativeJobFailures({ jobs, reportedIDs }).forEach(
            (job) => {
              reportedIDs.add(job.jobID);
              dispatch(reportCreativeJobError(job, advertiserID));
            }
          );
          setInitialSyncDone(true);
        },
      })
    );

    return () => {
      dispatch(
        stopListenerCreativeJobs({
          listenerRef: listenerRef.current,
        })
      );
      listenerRef.current = null;
    };
  }, [advertiserID, dispatch]);

  return { initialSyncDone };
};
